import React, { useState } from "react";
import "./navbar.scss";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const ducoLogo = process.env.PUBLIC_URL + "/duco-logo-no-baseline-White.png";

  window.onscroll = () => {
    setIsScrolled(window.pageYOffset === 0 ? false : true);
    return () => (window.onscroll = null);
  };

  const handleLoginClick = () => {
    window.location.href = process.env.REACT_APP_APIM_SIGN_IN_URI;
  };

  return (
    <div className={isScrolled ? "navbar scrolled" : "navbar"}>
      <div className="container">
        <div className="left">
          <img src={ducoLogo} alt="DUCO-logo" />
        </div>
        <div className="right">
          <>
            <span onClick={handleLoginClick}>Login</span>
          </>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
